import type { FC } from "react";

import clsx from "clsx";

import type { ITelemetryCustom } from "@/lib/telemetry";
import type { IButton } from "@Components/Button";
import { TelemetryEntity } from "@Components/Modules/Helpers";

import { TransitionButton } from "./Transition";

import * as css from "./ButtonsBar.module.css";

export interface IButtonsBar {
    className?: string;
    nextButton?: IButton;
    cancelButton?: IButton;
}

const buttonAjaxAction = (eventType: string) =>
    ({
        eventName: `${TelemetryEntity.Common}-${eventType}`,
        actionType: "Click",
    }) satisfies ITelemetryCustom;

export const ButtonsBar: FC<IButtonsBar> = ({ cancelButton, className, nextButton }) => (
    <div className={clsx(css.buttonsBarComponent, className)}>
        {cancelButton && (
            <TransitionButton
                {...cancelButton}
                appearance={"greyBlueRound"}
                hideLoading={true}
                trackingUrl={cancelButton.trackingUrl}
                telemetryCustom={!cancelButton.trackingUrl && buttonAjaxAction("Back")}
            />
        )}
        {nextButton && (
            <TransitionButton
                {...nextButton}
                appearance={"magentaRound"}
                hideLoading={true}
                trackingUrl={nextButton.trackingUrl}
                telemetryCustom={!nextButton.trackingUrl && buttonAjaxAction("Next")}
            />
        )}
    </div>
);
